import React from "react";

/** Session requests awaiting coordinator approval; `canCancel(request)` decides who sees the Cancel button. */
export default function PendingRequests({ requests, cancelingId, canCancel, onCancel }) {
  if (requests.length === 0) return null;
  return (
    <section>
      <div className="grp"><h3 className="warn">Pending approval · {requests.length}</h3></div>
      <div className="list">
        {requests.map((req) => (
          <div key={req.id} className="req">
            <div>
              <b>{req.sessionDate}</b>
              <span className="chip">Pending approval</span>
              <span className="muted">{req.sessionType}</span>
              <p>
                {req.location || req.meetingLink || ""}
                {req.startTime ? ` · ${req.startTime}–${req.endTime || ""}` : ""}
                {req.instructorName ? ` · ${req.instructorName}` : ""}
              </p>
            </div>
            {canCancel(req) && (
              <button type="button" className="btn btn-o" disabled={cancelingId === req.id} onClick={() => onCancel(req.id)}>
                {cancelingId === req.id ? "Cancelling…" : "Cancel request"}
              </button>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
